export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/refresh.5aeedb51.worker.js");
}
